var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "multi-value-picker" }, [
    _vm.selected.length
      ? _c("div", { staticClass: "selected" }, [
          _c(
            "ul",
            _vm._l(_vm.selected, function (v) {
              return _c(
                "li",
                {
                  key: v ? v.value : "x",
                  staticClass: "option",
                  attrs: {
                    "data-value": v ? v.value : "x",
                    title: _vm.$t("widgets.clickToRemove").toString(),
                  },
                  on: {
                    click: function ($event) {
                      return _vm.clickLabel($event?.target)
                    },
                  },
                },
                [_vm._v("\n\t\t\t\t" + _vm._s(v.label || v.value) + "\n\t\t\t")]
              )
            }),
            0
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.optionsNotYetSelected.length > 0
      ? _c(
          "div",
          { staticClass: "add" },
          [
            _c("SelectPicker", {
              attrs: {
                options: _vm.optionsNotYetSelected,
                value: _vm.selectValue,
                "data-menu-width": "grow",
                hideEmpty: "",
              },
              on: {
                input: function ($event) {
                  return _vm.add($event)
                },
              },
            }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }